import React from 'react'
import ResultsSection from './ResultsSection'
import parse from 'html-react-parser'
import useCareerExploration from './CareerExplorationProvider'
import useTranslation from '../shared/TranslationProvider'

const CareerDescriptionSection = ({ career, ...props }) => {
  const { careerDescriptionRef, careerDescription } = useCareerExploration()
  const description = careerDescription(career)
  return (
    <ResultsSection
      eleRef={careerDescriptionRef}
      section="career_development"
      career={career}
      {...props}
    >
      <CareerDescriptionInner description={description} />
    </ResultsSection>
  )
}

export default CareerDescriptionSection

const CareerDescriptionInner = ({ description }) => {
  const { t } = useTranslation('Page')
  if (!description) return <div>{t('not_available')}</div>
  return <div>{parse(description)}</div>
}
